import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { getCoupons } from '../../actions/coupon';
import bow from '../../images/bow.png';

const Coupon = ({ getCoupons, coupon: {coupons}}) => {
  
    useEffect(() => {
      getCoupons();
    }, [getCoupons]);
    
    return (
        <div className='pattern-bg'>
        <div className='container'>
            <h2 style={{color:'var(--primary-color)'}}><i className='fa-light fa-tag'></i> Exciting Offers @ GharBar </h2>
            <h6 style={{color: 'grey'}}>Coupons are the best way for guests to grab deals and discounts on homestays.</h6>
            <Row xs={1} md={3} className="g-4" style={{marginTop: '10px', marginBottom: '20px', paddingLeft: '25px', paddingRight: '25px'}}> 
                {coupons.map(coupon => (
                    <Col>
                    <div className = 'coupon-bow' data-aos='zoom-in-up'>
                        <img src={bow} class="ribbon" alt=""/>
                        <Card border='warning' className=' bs'>
                            <Card.Body>
                                <Row><Col><b style={{color: 'var(--primary-color)', fontSize: '1.5rem'}}>{coupon.discount}% Off</b></Col></Row>
                                <Row><Col>{coupon.roomtype}</Col></Row>
                                <Row><Col>Min Stay</Col><Col>{coupon.minduration} Days</Col></Row>
                                
                            </Card.Body>
                            <Card.Footer>
                            <Row>
                                <Col><h6 style={{marginLeft: '10px'}}>{coupon.couponcode}</h6></Col>
                                <Col><div className= 'btn btn-warning ' style={{float: 'right'}} onClick={() =>  navigator.clipboard.writeText(coupon.couponcode)}>
                                    <i className='fa-light fa-copy'/> Copy
                                </div></Col>
                            </Row>
                            </Card.Footer>
                        </Card>
                    </div>
                    </Col>
                ))}
            </Row>
        </div>
        </div>
    )
}

Coupon.propTypes = {
    coupon: propTypes.object.isRequired,
    getCoupons: propTypes.func.isRequired
}

const mapStateToProps = state => ({
    room: state.room,
    coupon: state.coupon
})

export default connect(mapStateToProps, {getCoupons})(Coupon);
